import { useQuery } from '@tanstack/react-query'
import { topRankingsKeys } from '@!/Api/queryKeys'
import { getTopRankingsApi } from '@!/Api/ranking'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useTopRankings = (genreTabName) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  const { data } = useQuery({
    queryKey: topRankingsKeys.filtered(safeSearch, genreTabName),
    queryFn: async () => {
      return await getTopRankingsApi(safeSearch, genreTabName)
    },
    refetchOnWindowFocus: false,
  })

  return data || []
}
